jQuery(document).ready(function ($) {
  "use strict";

  setTimeout(function () {
    if ($("[data-audio-button]").length) {
      var audio_player = WaveSurfer.create({
        barWidth: 1.6,
        barHeight: 1,
        barGap: 2,
        container: "#globalplayer",
        fillParent: true,
        height: 50,
        mediaControls: true,
        progressColor: "#F4C215",
        partialRender: false,
        waveColor: "white",
      });

      audio_player.load($("[data-audio-button]").first().attr("href"));
      audio_player.on("ready", function () {
        $("#progress").html("00:00");
        $("#total").html(getFormattedTime(audio_player.getDuration()));
      });

      // Show current time
      audio_player.on("audioprocess", function () {
        $("#progress").text(getFormattedTime(audio_player.getCurrentTime()));
      });

      audio_player.on("seek", function () {
        $("#playbutton").removeClass("is-active");
      });
    }

    $(document).on("click", "[data-audio-button]", function (e) {
      e.preventDefault();

      $(this).addClass("is-active");

      $(".sample-player").addClass("is-active");

      if (true == $(this).data("playing-sample")) {
        audio_player.pause();
        $(this).removeClass("is-active");
        $(this).data("playing-sample", false);
        $("#playbutton").removeClass("is-active");
      } else {
        if ($(this).attr("href")) {
          audio_player.load($(this).attr("href"));
          audio_player.on("ready", function () {
            audio_player.play();
            $("#total").text(getFormattedTime(audio_player.getDuration()));
          });

          $(this).data("playing-sample", true);
          $("#playbutton")
            .addClass("is-active")
            .data("current-sample", $(this).attr("href"));
        }
      }

      var play_elements = $(document).find(
        $("[data-audio-button]").not($(this))
      );

      play_elements.each(function (index, value) {
        $(value).removeClass("is-active");
        $(value).data("playing-sample", false);
      });
    });

    $("#playbutton").on("click", function (e) {
      e.preventDefault();

      $("#playbutton").toggleClass("is-active");

      audio_player.playPause();
      $('[href="' + $("#playbutton").data("current-sample") + '"]')
        .toggleClass("is-active")
        .data("playing-sample", false);
    });

    $("[data-sample-close]").on("click", function (e) {
      e.preventDefault();

      audio_player.pause();

      $(".sample-player").removeClass("is-active");

      var play_elements = $(document).find($("[data-audio-button]"));

      play_elements.each(function (index, value) {
        $(value).removeClass("is-active");
        $(value).data("playing-sample", false);
      });
    });
  });

  function getFormattedTime(seconds) {
    return [
      Math.floor((seconds % 3600) / 60), // minutes
      ("00" + Math.floor(seconds % 60)).slice(-2), // seconds
    ].join(":");
  }

  // Catch for delay function not firing
  $("[data-audio-button]").on("click", function (e) {
    e.preventDefault();
  });
}, 2500);
